import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { User_Progress } from "../../../redux/authslice";

const Sectionone = () => {
  const dispatch = useDispatch();

  const showdetail = useSelector((state) => state.counter.progressData);

  let token = localStorage.getItem("token");
  useEffect(() => {
    if (token) {
      dispatch(User_Progress(dispatch));
    }
  }, [token]);

  return (
    <section className="foundation-all">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="algebra-foundation">
              <div className="row">
                {/* ---------Progress quizzes------ */}
                <div className="col-lg-3">
                  <div className="progress-box">
                    <p className="progress-title">In progress quizzes</p>
                    <div className="progress-number">
                      <p className="progress-no">
                        {showdetail?.in_progress_quizzes}
                      </p>
                      <button className="progress-btn">
                        {/* <i className="fa-solid fa-arrow-up" />  */}
                        20%
                      </button>
                    </div>
                    <p className="progress-days">Last 7 days</p>
                  </div>
                </div>
                {/* ---------Completed quizzes------ */}
                <div className="col-lg-3">
                  <div className="progress-box">
                    <p className="progress-title">Completed quizzes</p>
                    <div className="progress-number">
                      <p className="progress-no">
                        {showdetail?.completed_quizzes}
                      </p>
                      <button className="progress-btn">
                        {/* <i className="fa-solid fa-arrow-up" /> */}
                        20%
                      </button>
                    </div>
                    <p className="progress-days">Last 7 days</p>
                  </div>
                </div>
                {/* ---------Completed quizzes------ */}
                <div className="col-lg-3">
                  <div className="progress-box">
                    <p className="progress-title">Completed quiz rate</p>
                    <div className="progress-number">
                      <p className="progress-no">
                        {showdetail?.completion_rate?.toFixed(0)}%
                      </p>
                      <button className="progress-btn">
                        {/* <i className="fa-solid fa-arrow-up" />  */}
                        20%
                      </button>
                    </div>
                    <p className="progress-days">Last 7 days</p>
                  </div>
                </div>
                {/* ---------Completed quizzes------ */}
                <div className="col-lg-3">
                  <div className="progress-box">
                    <p className="progress-title">Scores over 90%</p>
                    <div className="progress-number">
                      <p className="progress-no">{showdetail?.over_90_rate}%</p>
                      <button className="progress-btn">
                        {/* <i className="fa-solid fa-arrow-up" />  */}
                        20%
                      </button>
                    </div>
                    <p className="progress-days">Last 7 days</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sectionone;
